<template>
  <div class="painel col-12 p-5">
    <div class="container p-2">
      <div class="row">
        <div id="formulario" class="col-md-10 offset-md-1 my-3">
          <Titulo :sombra="false" titulo='Dê o primeiro passo' icon="" class="mb-4" posicao="center" />
          <formulario-cadastro></formulario-cadastro>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormularioCadastro from "./FormularioCadastro.vue";
import Titulo from "./Titulo.vue";
export default {
  name: "PainelFormulario",
  components: { Titulo, FormularioCadastro },
};
</script>

<style scoped>
p {
  display: block;
  text-align: center;
}

.painel {
  border-top: 3px 0 3px solid var(--cor-base-texto);
}

.bloco_icon {
  font-size: 1.3rem;
}

.bloco_icon span {
  border-bottom: 1px solid var(--cor-base-texto);
}

.icone_eleitor {
  color: white;
  background-color: var(--cor-base-texto);
  border: var(--cor-base-texto) 2px solid;
  font-size: 50px;
}

.titulo {
  font-size: 1.2rem;
}

.short_descr {
  font-size: 11px;
}

.bloco_formulario {
  /* background-color: rgb(255, 255, 255, 0.8); */
  background-color: white;
  height: 90%;
  padding: 4vh 10px 10vh;
  top: 0vh;
  position: relative;
  box-shadow: 3px 3px 5px var(--cor-fundo-base);
  border-radius: 4px;
}

.paragrafo {
  text-align: left !important;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 30px 20px 20px 10px;
  color: var(--cor-fundo-base)
}
</style>